import styled, { css, keyframes } from 'styled-components';

import { Spinner } from '../Spinner';

export const SPINNER_SIZE = 5.5;

const fadeOut = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    visibility: hidden;
  }
`;

interface SplashBgProps {
  $backgroundColor: string;
  $startFadeout: boolean;
}

const fadeOutStyle = ({ $startFadeout }) =>
  $startFadeout &&
  css`
    animation: ${fadeOut} 500ms forwards ease 500ms;
  `;

export const SplashBg = styled.div<SplashBgProps>`
  position: absolute;
  inset: 0;
  z-index: 4;
  background-color: ${({ $backgroundColor }) => $backgroundColor};
  ${fadeOutStyle}
`;

SplashBg.displayName = 'SplashBg';

export const StyledSpinner = styled(Spinner)`
  position: absolute;
  left: calc(50% - ${SPINNER_SIZE / 2}rem);
  top: calc(50% - ${SPINNER_SIZE / 2}rem);
  width: ${SPINNER_SIZE}rem;
  height: ${SPINNER_SIZE}rem;
`;

StyledSpinner.displayName = 'StyledSpinner';

interface PageSpinnerProps {
  $startFadeout: boolean;
}

export const PageSpinner = styled(StyledSpinner)<PageSpinnerProps>`
  ${fadeOutStyle}
`;

PageSpinner.displayName = 'PageSpinner';

export const CenteredSpinner = styled(Spinner)`
  position: absolute;
  left: calc(50% - ${SPINNER_SIZE / 2}rem);
  top: calc(50% - ${SPINNER_SIZE / 2}rem);
  width: ${SPINNER_SIZE}rem;
  height: ${SPINNER_SIZE}rem;
`;

CenteredSpinner.displayName = 'CenteredSpinner';
